import React from 'react';
import { Printer } from 'lucide-react';

export default function PrintMemberCard({ member }: { member: any }) {
  const handlePrint = async () => {
    let barcodeImg = '';
    try {
      const token = localStorage.getItem('liber_token');
      if (!member.barcode) {
        await fetch(`/api/barcode/member/${member.id}/assign`, {
          method: 'POST',
          headers: { 'Authorization': `Bearer ${token}` }
        });
      }
      const res = await fetch(`/api/barcode/member/${member.id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      barcodeImg = data.image || '';
    } catch(e) {}

    const html = `<!DOCTYPE html>
<html><head><title>წევრის ბარათი</title>
<style>
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:sans-serif;padding:20px;background:#fff}
  .card{border:2px solid #1d4ed8;border-radius:12px;padding:20px;max-width:350px;margin:0 auto}
  .header{display:flex;align-items:center;gap:12px;margin-bottom:16px;padding-bottom:12px;border-bottom:1px solid #e2e8f0}
  .avatar{width:48px;height:48px;border-radius:10px;background:#1d4ed8;display:flex;align-items:center;justify-content:center;font-size:22px;font-weight:700;color:white;flex-shrink:0}
  .name{font-size:16px;font-weight:700;color:#0f172a}
  .type{font-size:12px;color:#64748b;margin-top:2px}
  .logo{font-size:11px;color:#1d4ed8;font-weight:600;margin-top:2px}
  .fields{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:14px}
  .field{background:#f8fafc;border-radius:6px;padding:8px 10px}
  .field-label{font-size:10px;color:#94a3b8;margin-bottom:2px}
  .field-value{font-size:12px;font-weight:500;color:#0f172a}
  .barcode-section{text-align:center;padding-top:12px;border-top:1px solid #e2e8f0}
  .barcode-num{font-family:monospace;font-size:14px;font-weight:600;color:#1d4ed8;letter-spacing:1px;margin-top:6px}
  .footer{font-size:10px;color:#94a3b8;margin-top:6px}
  @media print{body{padding:0}}
</style></head><body>
<div class="card">
  <div class="header">
    <div class="avatar">${(member.first_name?.[0]||'?').toUpperCase()}</div>
    <div>
      <div class="name">${member.last_name} ${member.first_name}</div>
      <div class="type">${member.member_type || 'წევრი'}</div>
      <div class="logo">📚 Folios Library</div>
    </div>
  </div>
  <div class="fields">
    <div class="field"><div class="field-label">ელ-ფოსტა</div><div class="field-value">${member.email||'—'}</div></div>
    <div class="field"><div class="field-label">ტელეფონი</div><div class="field-value">${member.phone||member.home_phone||'—'}</div></div>
    <div class="field"><div class="field-label">სტატუსი</div><div class="field-value" style="color:${member.is_active?'#16a34a':'#dc2626'}">${member.is_active?'აქტიური':'გათიშული'}</div></div>
    <div class="field"><div class="field-label">რეგისტრაცია</div><div class="field-value">${member.created_at?new Date(member.created_at).toLocaleDateString('ka-GE'):'—'}</div></div>
  </div>
  <div class="barcode-section">
    ${barcodeImg ? `<img src="${barcodeImg}" style="width:100%;max-width:280px;margin:0 auto;display:block" />` : ''}
    <div class="barcode-num">${member.barcode||'—'}</div>
    <div class="footer">© 2026 Kakhaber Revazishvili · SANGU</div>
  </div>
</div>
</body></html>`;

    const win = window.open('', '_blank');
    if (!win) return;
    win.document.write(html);
    win.document.close();
    setTimeout(() => win.print(), 500);
  };

  return (
    <button onClick={handlePrint}
      style={{display:'flex',alignItems:'center',gap:5,padding:'7px 12px',background:'#111827',border:'1px solid #1e2d45',borderRadius:8,fontSize:12,color:'#60a5fa',cursor:'pointer'}}>
      <Printer size={13} /> ბარათის ბეჭდვა
    </button>
  );
}
